import { Injectable } from '@angular/core';
import { AbstractDialogService } from '@examdojo/core/dialog';
import { InviteUsersDialogComponent } from './invite-users-dialog.component';

@Injectable()
export class InviteUsersDialogService extends AbstractDialogService<void, boolean> {
  readonly id = 'invite-users-dialog';
  protected override readonly component = InviteUsersDialogComponent;

  protected override readonly options = {
    cssClass: 'modified-modal',
  };
}
